export interface Point {
	x: number;
	y: number;
}

export interface InitialSelection {
	anchor: number;
	head: number;
}

// The static element is replaced by the editor on click, so its press and release
// points are what survive of a drag. Map both; a release the editor cannot map
// (outside it) degrades to a caret at the press.
export function resolveInitialSelection(
	posAtPoint: (point: Point) => number | null,
	down: Point | null,
	up: Point | null,
): InitialSelection | null {
	const anchor = down ? posAtPoint(down) : null;
	if (anchor === null) return null;
	const head = up ? posAtPoint(up) : null;
	return { anchor, head: head ?? anchor };
}
